import React, { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { notification } from 'antd'
import { FormikHelpers } from 'formik'
import { useAuth } from '../../../services/auth'
import {
  ChangePasswordRequest,
  useChangePassword,
} from '../../../services/api/admin'
import { isValidationError } from '../../../services/api/client/types'
import { settingsPath } from '../../../routes/paths'
import { View } from './View'

export const Container: FunctionComponent = () => {
  const history = useHistory()
  const { setAuth } = useAuth()
  const [changePassword, { error }] = useChangePassword()
  const initialValues: ChangePasswordRequest = {
    password: '',
    oldPassword: '',
  }

  const onSubmit = (
    form: ChangePasswordRequest,
    { setErrors }: FormikHelpers<ChangePasswordRequest>
  ) => {
    return changePassword(form)
      .then(({ data }) => {
        setAuth(data.token, data.admin)
        notification.success({
          message: 'Пароль успешно обновлен',
          duration: 3,
        })
        history.push(settingsPath())
      })
      .catch((error) => {
        if (isValidationError(error)) {
          setErrors(error.fieldErrors)
        }
      })
  }

  return (
    <View error={error} initialValues={initialValues} onSubmit={onSubmit} />
  )
}
